import React from 'react';
import { Button, Modal } from 'antd-mobile';
import { URLS, jumpToH5 } from '../utils';

export const goLogin = (lang) => {
	// 跳转到登录
	const search = new URLSearchParams(window.location.search);
	const _scnl = search.get('_scnl');
	const url = URLS.Login[process.env.REACT_APP_ENV];
	jumpToH5(
		url,
		{
			_scnl,
			lang,
		},
		{
			isLogin: true,
			isBack: true,
		},
	);
};

export default (t, lang) => {
	const handleToLink = () => {
		modal.close();
		goLogin(lang);
	};

	const handleClose = () => {
		// 关闭弹窗
		modal.close();
	};

	const modal = Modal.show({
		content: (
			<div className='rc-alert' onClick={handleClose}>
				<div className='rc-alert-bd'>
					<p>{t('redeem.popup_redeem')}</p>
				</div>
				<div className='rc-alert-ft'>
					<Button className='rc-alert-btn' onClick={handleToLink}>
						{t('redeem.popup_login')}
					</Button>
				</div>
			</div>
		),
		closeOnMaskClick: true,
	});
};
